import bike1 from "./bike1.jpg";
import bike2 from "./bike2.jpg";
import bike3 from "./bike3.jpg";
import bike4 from './bike4.jpg';
import bike5 from './bike5.jpg';
import bike6 from './bike6.jpg';
import bike7 from './bike7.jpg';
import bike8 from './bike8.jpg';
import bike9 from './bike9.jpg';
import bike10 from './bike10.jpg';
import Flatbed1 from './Flatbed1.jpg';
import Flatbed2 from './Flatbed2.jpg';
import Flatbed3 from './Flatbed3.jpg';
import Flatbed4 from "./Flatbed4.jpg";
import Flatbed5 from "./Flatbed5.jpg";
import Flatbed6 from "./Flatbed6.jpg";
import Flatbed7 from "./Flatbed7.jpg";
import Flatbed8 from "./Flatbed8.jpg";
import Flatbed9 from "./Flatbed9.jpg";
import Flatbed10 from "./Flatbed10.jpg";
import Flatbed11 from "./Flatbed11.jpg";
import Flatbed12 from "./Flatbed12.jpg";
import Flatbed13 from "./Flatbed13.jpg";
import Flatbed14 from "./Flatbed14.jpg";
import Flatbed15 from "./Flatbed15.jpg";
import Flatbed16 from "./Flatbed16.jpg";
import Flatbed17 from "./Flatbed17.jpg";
import Flatbed18 from "./Flatbed18.jpg";
import Flatbed19 from "./Flatbed19.jpg";
import Flatbed20 from "./Flatbed20.jpg";
import Flatbed21 from "./Flatbed21.jpg";
// import Flatbed22 from "./flatbed23";
import Flatbed23 from "./flatbed23.jpg";
import Flatbed24 from "./flatbed24.jpg";
import Flatbed25 from "./flatbed25.jpg";
import Flatbed26 from "./flatbed26.jpg";
import Flatbed27 from "./flatbed27.jpg";
import Flatbed28 from "./flatbed28.jpg";
import Flatbed29 from "./flatbed29.jpg";
import Flatbed30 from "./flatbed30.jpg";
import video1 from "./video1.jpg";
import video2 from "./video2.jpg";
import video3 from "./video3.jpg";
import video4 from "./video4.jpg";
import logo from "./logo.png";
import CLOSED1 from "./closedcar1.jpg";
import CLOSED2 from './closedCar2.jpg';
import CLOSED3 from './closedCar3.jpg';
import CLOSED4 from './closedCar4.jpg';
import CLOSED5 from './closedCar5.jpg';
import CLOSED6 from './closedCar6.jpg';
import CLOSED7 from './closedCar7.jpg';
import UNDER1 from "./underLight.jpg";
import UNDER2 from "./underLift2.jpg";
import UNDER3 from "./underLift3.jpg";
import UNDER4 from "./underLift4.jpg";
import UNDER5 from "./underLift5.jpg";
import UNDER6 from "./underLift6.jpg";
import UNDER7 from "./underLift7.jpg";
import UNDER8 from "./underLift8.jpg";
import  UNDER9 from "./underLift9.jpg";
import UNDER10 from "./underLift10.jpg";
import UNDER11 from "./underLift11.jpg";
import UNDER12 from "./underLift12.jpg";
import UNDER13 from "./underLift13.jpg";
import UNDER14 from "./underLift14.jpg";
import UNDER15 from "./underLift15.jpg";
import UNDER16 from "./underLift16.jpg";
import heavy from './heavy.jpg'
import heavy1 from './heavy1.jpg'
import heavy2 from './heavy2.jpg'
import heavy3 from './heavy3.jpg';

const galleryData = {
  BIKE1: bike1,
  BIKE2: bike2,
  BIKE3: bike3,
  BIKE4: bike4,
  BIKE5: bike5,
  BIKE6: bike6,
  BIKE7: bike7,
  BIKE8: bike8,
  BIKE9: bike9,
  BIKE10: bike10,
  FLATBED1: Flatbed1,
  FLATBED2: Flatbed2,
  FLATBED3: Flatbed3,
  FLATBED4: Flatbed4,
  Flatbed5:Flatbed5,
  Flatbed6:Flatbed6,
  Flatbed7:Flatbed7,
  Flatbed8:Flatbed8,
  Flatbed9:Flatbed9,
  Flatbed10:Flatbed10,
  Flatbed12:Flatbed12,
  Flatbed11:Flatbed11,
  Flatbed13: Flatbed13,
  Flatbed14: Flatbed14,
  Flatbed15: Flatbed15,
  Flatbed16: Flatbed16,
  Flatebed17 : Flatbed17,
  Flatbed19 : Flatbed19,
  Flatbed20 : Flatbed20,
  Flatbed21 : Flatbed21,
  // Flatbed22 : Flatbed22,
  Flatbed23 : Flatbed23,
  Flatbed24 : Flatbed24,
  Flatbed25 : Flatbed25,
  Flatbed26 : Flatbed26,
  Flatbed27 : Flatbed27,
  Flatbed28 : Flatbed28,
  Flatbed29 : Flatbed29,
  Flatbed30 : Flatbed30,
  CLOSED1: CLOSED1,
  CLOSED2:CLOSED2,
  CLOSED3:CLOSED3,
  CLOSED4:CLOSED4,
  CLOSED5:CLOSED5,
  CLOSED6:CLOSED6,
  CLOSED7:CLOSED7,
  VIDEO1: video1,
  VIDEO2: video2,
  VIDEO3: video3,
  VIDEO4: video4,
  LOGO: logo,
  UNDER1: UNDER1,
  UNDER2:UNDER2,
  UNDER3:UNDER3,
  UNDER4:UNDER4,
  UNDER5:UNDER5,
  UNDER6:UNDER6,
  UNDER7:UNDER7,
  UNDER8:UNDER8,
  UNDER9:UNDER9,
  UNDER10:UNDER10,
  UNDER11:UNDER11,
  UNDER12:UNDER12,
  UNDER13:UNDER13,
  UNDER14:UNDER14,
  UNDER15:UNDER15,
  UNDER16:UNDER16,
  HEAVY:heavy,
  HEAVY1:heavy1,
  HEAVY2:heavy2,
  heavy3:heavy3
};

export default galleryData;
